export const rewriterTones = ['calm', 'assertive', 'boundary-setting']
